import React, {FC} from 'react';

type Props = {
  value: string;
};

export const InputSubmitButton: FC<Props> = ({value}) => (
  <input type="submit" className="text-white cursor-pointer w-full p-5 rounded-lg flex justify-center items-center trakDarkGradient" value={value} />
);
